import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { Modal } from "../../../theme/Component/Modal";
import { toast } from "react-toastify";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { _ActiveItemsHistory, _ImportEmployeeFactors, _ImportEmployeeFactorsByexe, _ProcessImported } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { FileInput } from "../../../theme/Component/FileInput";



export const ActiveItemsHistory = () => {

    const imphist = useDataBean(_ActiveItemsHistory);
    const [formato, setFormato] = useState<any>([]);
    const [modallinkdos, setModallinkdos] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });


    const importFixedAssetItemHistory = () => {
        imphist.instance.importFixedAssetItemHistory(imphist.bean.Media, imphist.bean.MediaContext, null, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Importado')
                    setFormato(resp[0]);
                    setModallinkdos({ ...modallinkdos, "view": true })
                    console.log(resp)
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    return (
        <BasicPage titulo="Importar Historico de Asignación de Items">
            <div className="row">
                <div className="col-md-12">
                    <FileInput
                        label='Archivo a importar'
                        directory='ImpoFactorSalarial'
                        onCreate={({ Media, MediaContext }) => { imphist.setBean({ ...imphist.bean, "Media": Media, "MediaContext": MediaContext }) }}
                    />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-database-2-line" disable={!imphist.bean.Media} eventClick={importFixedAssetItemHistory}>Importar Archivo</BasicButton>
                </div>
                <div className="col-md-12">
                    <Modal modal={modallinkdos} updateModal={setModallinkdos}>
                        <div className="row">
                            <div className="col-md-12">
                                {formato?.DataBeanProperties?.URLLink && (
                                    // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                    <div className="row">
                                        <div className="col-md-12 mt-3">
                                            <label>Descarga en el Siguiente Link:*</label>
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <a href={formato.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                                <strong>📄 {formato.DataBeanProperties.Filename}</strong>
                                            </a>
                                        </div>
                                    </div>

                                )}
                            </div>
                        </div>
                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}